import React, { Component } from "react"
import trans from "trans"

import {
    Grid,
    GridCell,
    modal,
    Icon,
    Theme,
    Toggler,
} from "@bdfx/mergado-ui-kit"

import Shape, { SOURCE_IMAGE_TYPE } from "shape-entities/types/shape";
import { Provider, connect } from "react-redux";
import { AlternativeTemplate, Template } from "app/types/model-types";
import _debounce from 'lodash/debounce';
import { renderClipMaskShape } from "template-edit/components/helper";
import EditClipMaskModal from "./edit-clip-mask-modal";
import store from 'store';
import { isJson } from "app/helpers/other";
import { iconDisabledColor } from "template-edit/components/tools-panel";
import { selectFormValues } from "app/reducers/form";
import { StyledSeparator } from "./common-shape-form";
import { getFormName, SOURCE_IMAGE_INDEX } from "./helpers";
import { TemplateOrAlternativeTemplateType } from "template-edit/undoRedoReducers";

interface Props {
    shape: Shape
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    onlyMask?: boolean
}

class ClipMaskForm extends Component<Props> {
    constructor(props) {
        super(props)
    }

    editMaskModal = (shape: Shape) => {
        modal({
            overlayClassName: 'edit-clip-mask-modal',
            style: { width: '96vw', height: '96vw' },
            title: trans('clip_mask'),
            message: (close) => <Provider store={store}>
                <EditClipMaskModal shape={shape} />
            </Provider>

        })
    }

    render() {
        const { form, shape, onlyMask, isAlt } = this.props

        if (!shape) {
            return <React.Fragment />
        }

        const clipMaskObjects = shape && shape.clip_mask && shape.clip_mask !== '[]' && isJson(shape.clip_mask) ? JSON.parse(shape.clip_mask) : null

        if (!clipMaskObjects) {
            return <span className={'clickable centered'} title={trans('add_clip_mask')} onClick={() => this.editMaskModal(shape)} style={{ padding: '5px' }}>
                <Icon type={'plus-square'} color={iconDisabledColor} size={10} />
            </span>
        }

        const formName = getFormName(isAlt)

        const width = shape.type === SOURCE_IMAGE_TYPE ? form.size.width : shape.width
        const height = shape.type === SOURCE_IMAGE_TYPE ? form.size.height : (shape.height || shape.width)

        const maskSVG = <svg version="1.1" viewBox={`0 0 ${width} ${height}`} width={width} height={height} onClick={() => this.editMaskModal(shape)}
            style={{
                width: onlyMask ? '32px' : 'auto',
                height: onlyMask ? '32px' : 'auto',
                marginLeft: onlyMask ? '4px' : undefined,
                maxWidth: '100%',
                background: shape.invert_clip_mask ? '#eee' : iconDisabledColor,
                cursor: 'pointer',
            }}>
            {clipMaskObjects && Array.isArray(clipMaskObjects) &&
                clipMaskObjects.map((maskObject, idx) => <React.Fragment key={`clip_path_${idx}`}>
                    {renderClipMaskShape(maskObject, true, !!shape.invert_clip_mask)}
                </React.Fragment>)
            }
        </svg>

        if (onlyMask) {
            return maskSVG
        }

        return (
            <React.Fragment>
                <Grid cols={'1fr 1fr'}>
                    <GridCell col={'1/-1'}><StyledSeparator /></GridCell>
                    <GridCell>{trans('clip_mask')}</GridCell>
                    {/* <GridCell onClick={() => this.editMaskModal(shape)} className={'clickable centering'}>
                    <svg version="1.1" viewBox={`0 0 ${width} ${height}`} width={width} height={height} className={'shadow-box'} style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: '100%' }}>
                        <g transform={`translate(${width / 2},${height / 2})`}>
                            {getShapeByType(shape, { width: width, height: height }, true, activeShapeId, editMode)}
                        </g>
                    </svg>
                    </GridCell> */}
                    <GridCell className={'clickable centering'} title={trans('edit')}>{maskSVG}</GridCell>
                    <GridCell>{trans('invert_clip_mask')}</GridCell>
                    <GridCell><Toggler name={`${formName}.shapes.${shape.index}.invert_clip_mask`} /></GridCell>
                </Grid>
            </React.Fragment>
        )
    }
}


function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
    }
}

export default connect(mapStateToProps, {
})(ClipMaskForm)

